// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3ml5h","fileBtn":"File_fileBtn__1kLSO","closeBtn":"File_closeBtn__1vI0v","fileSelected":"File_fileSelected__E1hXT","disabled":"File_disabled__2MEAA"};